<div #bar class="bar">
  <div class="percentage" [style.width.%]="percent"></div>
</div>

<div class="position" [style.left.%]="percent"></div>
